import { getDate as getDateFns } from 'date-fns';

export default function getDate(date: Date): number {
  return getDateFns(date);
}
